export default __webpack_public_path__ + "static/media/israel.3fddeccc.svg";